import { Component, OnInit } from '@angular/core';
import { RadnoVreme } from './radno-vreme';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'yt-radno-vreme-modal-update',
  templateUrl: './radno-vreme-modal-update.component.html'
})
export class RadnoVremeModalUpdateComponent 
extends BaseModalUpdateComponent<RadnoVreme>
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<RadnoVreme>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
 

  ngOnInit() {
    super.ngOnInit();
  }

}
